import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';
import { getCallableMessage, unwrapCallableData } from './callableResponse';
import { CustomProductBulkTarget } from '../types/customProductBulkActions';

interface GenerateAmazonContentForCustomProductRequest {
    productId: string,
    companyId: string
}

interface GenerateAmazonContentForCustomProductResponse {
    productId: string;
    quotaReached?: boolean;
    message?: string;
}

const generateAmazonContentForCustomProduct = async (productId: string, companyId: string): Promise<GenerateAmazonContentForCustomProductResponse> => {
    const analyzeShopifyShop = httpsCallable<GenerateAmazonContentForCustomProductRequest, GenerateAmazonContentForCustomProductResponse>(functions, 'handle_generated_amazon_content_for_custom_product');
    const result = await analyzeShopifyShop({ productId, companyId });
    return {
        ...unwrapCallableData<GenerateAmazonContentForCustomProductResponse>(result.data),
        message: getCallableMessage(result.data),
    };
};


type GenerateAmazonContentForCustomProductsRequest = {
    companyId: string
} & Partial<CustomProductBulkTarget>;

interface GenerateAmazonContentForCustomProductsResponse {
    companyId?: string;
    scheduledCount: number;
    requestedCount?: number;
    quotaReached: boolean;
    jobCreated?: boolean;
    message?: string;
}

const generateAmazonContentForCustomProducts = async (companyId: string, target?: CustomProductBulkTarget): Promise<GenerateAmazonContentForCustomProductsResponse> => {
    const generateAmazonContentForCustomProducts = httpsCallable<GenerateAmazonContentForCustomProductsRequest, GenerateAmazonContentForCustomProductsResponse>(functions, 'handle_generated_amazon_content_for_custom_products');
    const result = await generateAmazonContentForCustomProducts({ companyId, ...target });
    return {
        ...unwrapCallableData<GenerateAmazonContentForCustomProductsResponse>(result.data),
        message: getCallableMessage(result.data),
    };
};


export { generateAmazonContentForCustomProducts, generateAmazonContentForCustomProduct };
